import { UserRole } from '@modules/types/graphql';

export const roleTranslates = {
    [UserRole.admin]: 'Администратор',
    [UserRole.testable]: 'Участник',
};
